import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useSiteContent } from '../../content/useSiteContent'

const ID_RE = /^G-[A-Z0-9]{6,14}$/

/** Sends page views to Google Analytics once a measurement ID is saved in the dashboard (Website settings). Renders nothing. */
export default function GoogleAnalytics() {
  const { site } = useSiteContent()
  const id = site.analytics?.google_analytics_id || ''
  const { pathname, search } = useLocation()
  const on = ID_RE.test(id) && !pathname.startsWith('/admin')

  useEffect(() => {
    if (!on || window.__gaId === id) return
    window.dataLayer = window.dataLayer || []
    window.gtag = function gtag() { window.dataLayer.push(arguments) } // eslint-disable-line prefer-rest-params
    window.gtag('js', new Date())
    window.gtag('config', id, { send_page_view: false }) // page views are sent below, on every route change
    const s = document.createElement('script')
    s.async = true
    s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`
    document.head.appendChild(s)
    window.__gaId = id
  }, [on, id])

  useEffect(() => {
    if (on && window.__gaId === id && window.gtag) {
      window.gtag('event', 'page_view', { page_path: pathname + search, page_location: window.location.href, page_title: document.title })
    }
    // Track PageView on SPA route changes for Meta Pixel
    if (!pathname.startsWith('/admin') && typeof window !== 'undefined' && typeof window.fbq === 'function') {
      window.fbq('track', 'PageView')
    }
  }, [on, id, pathname, search])

  return null
}
